import { routeApis } from "../../constants/apis";
import { RequestMethods } from "../../constants/fetch";
import { Routes } from "../../constants/routes";
import {
  activateBasicFetch,
  fetchJSON,
  setFetchOpts,
} from "../../helpers/fetch";
import { getPageData } from "../templates/page";

export const pendingRegistrationsLoader = async (props: any) => {
  const portalRegions = await getPortalHubs(
    routeApis[Routes.PENDING_REGISTRATIONS].getPortalHubs
  );

  return await getPageData({
    url: routeApis[Routes.PENDING_REGISTRATIONS].getPendingItems,
    passThroughData: {
      queryBannerFilterConfig: {
        portalRegions,
      },
    },
    ...props,
  });
};

export const getPortalHubs = async (url: string) => {
  const fetchOptions = setFetchOpts({
    method: RequestMethods.GET,
  });

  const { data } = await fetchJSON(url, fetchOptions, 10000);

  return data;
};

export const reSubmitPendingRegistration = async (url: string, data: any) => {
  const { azureUserId, email, portal } = data;

  const fetchOptions = setFetchOpts({
    method: RequestMethods.POST,
    body: {
      azureUserId,
      email,
      portal,
    },
  });

  return await activateBasicFetch(url, fetchOptions);
};

export const rejectPendingRegistration = async (url: string, data: any) => {
  const { azureUserId, portal, email } = data;

  const fetchOptions = setFetchOpts({
    method: RequestMethods.POST,
    body: {
      azureUserId,
      email,
      portal,
    },
  });

  return await activateBasicFetch(url, fetchOptions);
};
